<template>
  <b-modal
    id="editPreOrder-pre-order"
    :titleHtml="titelModal"
    hide-footer
    size="xl"
    scrollable
    @hidden="handleModalClosed"
  >
    <div>
      <b-row>
        <b-col :cols="isCreate ? 12 : 9">
          <div v-if="preOrder.orderWarning">
            <b-alert show variant="warning">
              <i class="fa fa-exclamation-triangle text-warning"></i>
              <strong class="text-dark">
                {{ preOrder.orderWarningName }}</strong
              ></b-alert
            >
          </div>
          <b-row>
            <b-col md="4">
              <p class="text-dark font-size-h5 font-weight-bold">
                Đơn đặt trước
              </p>
              <!-- Ô Chương trình chỉ có khi TẠO MỚI: đơn đang sửa đã gắn sẵn chương trình (hiện ở tiêu đề) -->
              <b-form-group>
                <label
                  >Nguồn đơn hàng:
                  <span v-if="isCreate" class="text-danger">*</span></label
                >
                <b-form-select
                  v-model="preOrder.orderSourceId"
                  :options="orderSourceOptions"
                  size="sm"
                  class="select-style"
                  value-field="id"
                  text-field="name"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null"
                      >-- Chọn nguồn đơn hàng --</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </b-form-group>
              <template v-if="isCreate">
                <b-form-group>
                  <label>Chương trình: <span class="text-danger">*</span></label>
                  <vue-autosuggest
                    :suggestions="optionForms"
                    :get-suggestion-value="(form) => form.item.name"
                    :limit="10"
                    :input-props="{
                      class: 'autosuggest__input',
                      placeholder: 'Tên chương trình',
                    }"
                    :should-render-suggestions="
                      (size, loading) => size >= 0 && !loading
                    "
                    @input="onInputed($event, 'Form')"
                    @selected="onSelectedForm"
                    v-model="preOrder.formName"
                  >
                    <div slot-scope="{ suggestion }">
                      {{ suggestion.item.name }}
                    </div>
                  </vue-autosuggest>
                </b-form-group>
              </template>
              <b-form-group>
                <label>Cửa hàng:</label>
                <vue-autosuggest
                  :suggestions="optionStores"
                  :get-suggestion-value="(store) => store.item.name"
                  :limit="10"
                  :input-props="{
                    class: 'autosuggest__input',
                    placeholder: 'Tên cửa hàng',
                    disabled: preOrder.orderId,
                  }"
                  :should-render-suggestions="
                    (size, loading) => size >= 0 && !loading
                  "
                  @input="onInputed($event, 'Store')"
                  @selected="(option) => (preOrder.storeId = option.item.id)"
                  v-model="preOrder.storeName"
                >
                  <div slot-scope="{ suggestion }">
                    {{ suggestion.item.name }}
                  </div>
                </vue-autosuggest>
              </b-form-group>
              <b-form-group>
                <label>Trạng thái:</label>
                <b-form-select
                  v-model="preOrder.status"
                  :options="optionStatus"
                  size="sm"
                  class="select-style"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </b-form-group>
              <b-form-group>
                <label>Ghi chú:</label>
                <b-form-textarea
                  size="sm"
                  class="input-style"
                  v-model="preOrder.notes"
                  :placeholder="'Thêm ghi chú'"
                  :rows="3"
                  :max-rows="6"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <p class="text-dark font-size-h5 font-weight-bold">
                Thông tin khách hàng
              </p>
              <b-form-group>
                <label>Điện thoại: <span class="text-danger">*</span></label>
                <vue-autosuggest
                  :suggestions="optionCustomers"
                  :get-suggestion-value="(customer) => customer.item.phoneNo"
                  :limit="10"
                  :input-props="{
                    class: 'autosuggest__input',
                    placeholder: 'SĐT Khách hàng',
                    disabled: preOrder.orderId,
                  }"
                  :should-render-suggestions="
                    (size, loading) => size >= 0 && !loading
                  "
                  @input="onInputed($event, 'Customer')"
                  v-model="preOrder.customerMobile"
                  @selected="onSelected($event, 'Customer')"
                >
                  <div slot-scope="{ suggestion }">
                    <span class="mr-1">{{ suggestion.item.phoneNo }}</span>
                    <span
                      class="text-primary"
                      v-if="
                        suggestion.item.fullName &&
                        suggestion.item.fullName.trim().length > 0
                      "
                    >
                      - {{ suggestion.item.fullName }}
                    </span>
                  </div>
                </vue-autosuggest>
              </b-form-group>
              <b-form-group>
                <label
                  >Họ tên:<span class="text-primary">{{
                    preOrder.totalPointText
                  }}</span></label
                >
                <b-form-input
                  class="input-style"
                  size="sm"
                  v-model="preOrder.customerName"
                  placeholder="Họ tên khách hàng"
                  :disabled="preOrder.orderId ? true : false"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label>Email:</label>
                <b-form-input
                  class="input-style"
                  size="sm"
                  v-model="preOrder.customerEmail"
                  placeholder="Email khách hàng"
                  :disabled="preOrder.orderId ? true : false"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label>Địa chỉ:</label>
                <b-form-textarea
                  size="sm"
                  class="input-style"
                  v-model="preOrder.customerAddress"
                  :placeholder="'Thêm địa chỉ khách hàng'"
                  :rows="3"
                  :max-rows="6"
                  :disabled="preOrder.orderId ? true : false"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <div class="d-flex">
                <p class="text-dark font-size-h5 font-weight-bold mr-1">
                  Thông tin thanh toán
                </p>
                <span v-if="preOrder.partnerPaymentStatus === 2">
                  <b-badge variant="secondary">Chưa thanh toán</b-badge>
                </span>
                <span v-else-if="preOrder.partnerPaymentStatus === 1">
                  <b-badge variant="success">Đã thanh toán</b-badge>
                </span>
              </div>

              <b-form-group>
                <label class="mr-1">Trả trước:</label>

                <b-form-input
                  class="input-style text-right"
                  size="sm"
                  v-mask.raw="mask"
                  v-model="preOrder.installMoneyAmount"
                  placeholder="Trả góp"
                  :disabled="isPaymentLocked"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label>Dịch vụ trả góp:</label>
                <vue-autosuggest
                  :suggestions="optionInstallment"
                  v-model="preOrder.installmentMoneyAccountName"
                  :limit="100"
                  :input-props="{
                    class: 'autosuggest__input',
                    placeholder: 'Dịch vụ trả góp',
                    disabled: isPaymentLocked,
                  }"
                  @input="onInputed($event, 'Installment')"
                  @selected="
                    (option) =>
                      (preOrder.installMoneyAccountId = option.item.id)
                  "
                >
                  <div slot-scope="{ suggestion }">
                    {{ suggestion.item.name }}
                  </div>
                </vue-autosuggest>
              </b-form-group>
              <b-form-group>
                <label>Mã hợp đồng:</label>
                <b-form-input
                  size="sm"
                  v-model="preOrder.installMoneyCode"
                  placeholder="Nhập mã"
                  :disabled="isPaymentLocked"
                ></b-form-input>
              </b-form-group>
              <p v-if="isCreate" class="text-muted" style="font-size: 12px">
                Thanh toán được ghi nhận sau khi tạo đơn.
              </p>
            </b-col>
          </b-row>
          <b-tabs v-model="activeTabIndex" content-class="mt-3">
            <b-tab title="Sản phẩm khách muốn sở hữu">
              <ProductMapping
                :items="preOrdersProduct"
                :suggestions="optionProducts"
                :search-text.sync="preOrder.productNameSearch"
                :search-type-value.sync="preOrder.searchProductType"
                :loading="onLoading"
                :disabled="!!preOrder.orderId"
                :searchTypeDisabled="true"
                :header-text="formatProductName(preOrder)"
                :header-price="preOrder.productPrice"
                :table-fields="preOrdersProductFields"
                :config="productSearchConfig"
                @search-input="onInputed($event, 'Product')"
                @item-selected="onSelected({ item: $event }, 'Product')"
                @remove-item="removePreOrdersProduct"
              />
            </b-tab>
            <b-tab title="Sản phẩm thu cũ">
              <ProductMapping
                :items="[selectedTradeInProduct]"
                :loading="onLoading"
                :disabled="!!preOrder.orderId"
                :table-fields="tradeInTableFields"
                :search-type-value.sync="preOrder.searchTradeInType"
                :searchTypeDisabled="true"
                :config="tradeInSearchConfig"
                @item-selected="onSelectTradeInProduct"
                @search-change="onTradeInSearchChange"
              >
                <template #top>
                  <div v-if="preOrder.customerCurrentPhone">
                    <div class="d-flex align-items-center mb-4 flex-wrap">
                      <span class="mr-2"> Điện thoại khách đang sở hữu: </span>

                      <span
                        class="font-weight-bold mr-2"
                        :class="
                          isCustomerProductMapped
                            ? 'text-primary'
                            : 'text-danger'
                        "
                        style="font-size: 1.1rem; line-height: 1"
                      >
                        {{ preOrder.customerCurrentPhone }}
                      </span>
                    </div>
                  </div>
                </template>
                <template #tree-option="{ node }">
                  <div>
                    <b class="text-primary">
                      ({{ convertPrice(node.raw.sellingPrice) }})
                    </b>
                    {{ node.raw.label }}
                  </div>
                </template>
              </ProductMapping>
            </b-tab>
          </b-tabs>
        </b-col>
        <b-col cols="3" v-if="!isCreate">
          <b-row>
            <b-col>
              <p class="text-dark font-size-h5 font-weight-bold">
                Thông tin khác
              </p>
              <div v-if="preOrder.wantUpgrade !== null">
                <label class="font-weight-bold"> Khách muốn lên đời: </label>
                <p
                  class="mt-1"
                  v-html="
                    preOrder.wantUpgrade === true
                      ? '&bull; Có nhu cầu'
                      : '&bull; Không có nhu cầu'
                  "
                ></p>
              </div>
              <div v-for="(item, index) in preOrder.attributes" :key="index">
                <div v-if="item.value">
                  <label>
                    <span v-if="!item.text"> {{ item.key }}:</span>
                    <span v-else> {{ item.text }}:</span>
                  </label>
                  <div class="mt-1" v-html="'&bull; ' + item.value"></div>
                </div>
              </div>
              <b-form-group v-if="preOrder.id">
                <template slot="label">&nbsp;</template>
                <b-card no-body>
                  <b-card-header
                    style="
                      padding: 12px 12px 5px 12px;
                      background-color: #f1f1f1;
                    "
                  >
                    <div class="d-flex">
                      <i
                        class="fas fa-history mr-2"
                        style="padding-top: 0.5px"
                      ></i>
                      <h6>Lịch sử</h6>
                    </div>
                  </b-card-header>
                  <b-card-body class="p-1 pb-0 history-scroll">
                    <b-table-simple responsive id="history-table">
                      <b-tbody v-for="item in histories" :key="item.id">
                        <b-tr>
                          <b-td style="width: 45%">
                            <b>{{ item.createdByName }}</b>
                            <span style="font-size: 10px">{{
                              item.createdAt
                            }}</span>
                          </b-td>
                          <b-td style="width: 55%">
                            {{ item.actionName }}
                            <span v-if="item.action === 3">
                              {{ item.newValue.statusName }}
                            </span>
                            <span v-else>
                              <span
                                v-if="
                                  item.originalValue.status !==
                                  item.newValue.status
                                "
                              >
                                {{ item.originalValue.statusName }}
                                ->
                                {{ item.newValue.statusName }}</span
                              >
                            </span>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-card-body>
                </b-card>
              </b-form-group>
              <b-form-group v-if="preOrder.id">
                <template slot="label">&nbsp;</template>
                <b-card no-body>
                  <b-card-header
                    style="
                      padding: 12px 12px 5px 12px;
                      background-color: #f1f1f1;
                    "
                  >
                    <div class="d-flex">
                      <i
                        class="fas fa-store mr-2"
                        style="padding-top: 0.5px"
                      ></i>
                      <h6>Ghi chú Cửa hàng</h6>
                    </div>
                  </b-card-header>
                  <b-card-body class="p-1 pb-0 history-scroll">
                    <b-table-simple responsive id="store-note-table">
                      <b-tbody
                        v-for="item in storeNotes"
                        :key="item.id"
                      >
                        <b-tr>
                          <b-td style="width: 45%">
                            <b>{{ item.createdByName }}</b>
                            <span
                              v-if="item.storeName"
                              style="font-size: 10px"
                              >{{ item.storeName }}</span
                            >
                            <span style="font-size: 10px">{{
                              item.createdAt
                            }}</span>
                          </b-td>
                          <b-td style="width: 55%">{{ item.content }}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <div
                      v-if="!storeNotes.length"
                      class="text-center text-muted p-2"
                      style="font-size: 12px"
                    >
                      Chưa có ghi chú cửa hàng
                    </div>
                  </b-card-body>
                </b-card>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <div>
      <b-row>
        <b-col>
          <SaveButton
            v-if="isCreate"
            :button-style="{ minWidth: '70px', whiteSpace: 'nowrap' }"
            button-class="mr-3"
            :is-busy="isSubmitting('create')"
            @click="callCreatePreOrder"
            >Lưu</SaveButton
          >
          <SaveButton
            v-else
            :button-style="{ minWidth: '70px', whiteSpace: 'nowrap' }"
            button-class="mr-3"
            :is-busy="isSubmitting('update')"
            :disabled="isProcessing"
            @click="callUpdatePreOrderBy('update')"
            >Lưu</SaveButton
          >
          <b-button
            style="width: 70px"
            variant="secondary"
            size="sm"
            class="mr-3"
            :disabled="isProcessing"
            @click="$bvModal.hide('editPreOrder-pre-order')"
            >Hủy</b-button
          >
          <SaveButton
            v-if="!preOrder.orderId && !isCreate"
            :button-style="{ fontWeight: '600', whiteSpace: 'nowrap' }"
            variant="warning"
            :is-busy="isSubmitting('moveToOrder')"
            :disabled="isProcessing"
            @click="callUpdatePreOrderBy('moveToOrder')"
            >Chuyển qua đơn hàng</SaveButton
          >
        </b-col>
      </b-row>
    </div>
    <ConfirmActionModal
      ref="preorder-conflict-modal"
      title="Đơn đặt trước đã thay đổi"
      message="Đơn đặt trước này vừa được cập nhật bởi một thao tác khác (thanh toán hoặc người dùng khác) trong lúc bạn đang chỉnh sửa. Bấm để tải lại dữ liệu mới nhất và chỉnh sửa lại."
      confirm-text="Tải lại dữ liệu"
      @confirm="reloadPreOrderData"
    />
  </b-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import ApiService from '@/core/services/api.service';
import { checkPermissions } from '../../../utils/saveDataToLocal';
import {
  convertPrice,
  makeToastFaile,
  makeToastSuccess,
  currencyMask,
  unMaskPrice,
  removeAccents,
} from '../../../utils/common';
import { cloneDeep, assign, isEmpty, debounce, map } from 'lodash';
import { PREORDER_STATUS, TIME_TRIGGER } from '../../../utils/constants';
import { PRE_ORDER_FORM_TYPE } from '@/utils/enum';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import ProductMapping from './ProductMapping.vue';
import ConfirmActionModal from '../ConfirmActionModal.vue';
import SaveButton from '@/view/components/common/SaveButton.vue';
import submitLock from '@/view/mixins/submit-lock.mixins';

export default {
  // forms: danh sách chương trình đặt trước, chỉ dùng ở chế độ tạo mới
  props: ['params', 'stores', 'forms'],
  mixins: [validationMixin, submitLock],
  components: {
    ProductMapping,
    ConfirmActionModal,
    SaveButton,
  },
  data() {
    return {
      mask: currencyMask,
      preOrder: {
        orderId: null,
        storeId: null,
        customerId: null,
        customerMobile: null,
        customerName: null,
        customerEmail: null,
        customerAddress: null,
        formId: null,
        formName: null,
        orderSourceId: null,
        status: 1,
        notes: null,
        productId: null,
        productName: null,
        productNameSearch: null,
        searchProductType: 1,
        installMoneyAccountId: null,
        installMoneyCode: null,
        installMoneyAmount: 0,
        partnerPaymentStatus: null,
        attributes: [],
        products: [],
        totalPointText: null,
        id: null,
        updatedAt: null,
        customerProductId: null,
        customerProduct: {
          customerProductName: null,
        },
      },
      preOrdersProductFields: [
        {
          key: 'productNameSystem',
          label: 'Tên sản phẩm',
          thClass: 'text-center',
        },
        {
          key: 'barCode',
          label: 'Barcode',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'productCode',
          label: 'Mã sản phẩm',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'sellingPrice',
          label: 'Số tiền',
          thClass: 'text-center',
          tdClass: 'text-right',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'text-center',
          tdClass: 'text-right',
        },
      ],
      tradeInTableFields: [
        {
          key: 'productName',
          label: 'Sản phẩm',
          thClass: 'text-center',
        },
        {
          key: 'barCode',
          label: 'Barcode',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'productCode',
          label: 'Mã sản phẩm',
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          key: 'sellingPrice',
          label: 'Giá thu dự kiến',
          thClass: 'text-center',
          tdClass: 'text-right',
        },
      ],
      activeTabIndex: 0,
      preOrdersProduct: [],
      optionStatus: PREORDER_STATUS.filter(
        (status) => status.checked === false,
      ),
      tradeInDataReady: false,
      defaultTradeInOptions: [],
      isOpenTradeInSearch: false,
      tradeInProductSearch: {
        placeHolder: 'Tìm kiếm theo tên, mã, mã vạch sản phẩm',
      },
      onLoadingList: false,
      isBusy: false,
      selectedTradeInProduct: {
        productId: null,
        productName: null,
        productCode: null,
        barCode: null,
        sellingPrice: null,
      },
      onLoading: false,
      filteredStores: [],
      titelModal: null,
      filteredInstallments: [],
      filteredProducts: [],
      filteredCustomers: [],
      histories: [],
      storeNotes: [],
      // Modal này dùng chung cho SỬA và TẠO MỚI — tạo mới chỉ khác: có thêm nguồn
      // đơn hàng + chương trình, không có cột lịch sử, và Lưu gọi POST thay vì PUT.
      isCreate: false,
      orderSources: [],
      filteredForms: [],
    };
  },
  computed: {
    // Khóa cả nhóm nút ghi khi một request đang bay: nút Lưu và nút Chuyển qua
    // đơn hàng cùng gọi PUT /pre-orders trên cùng bản ghi.
    isProcessing() {
      return (
        this.isSubmitting('update') ||
        this.isSubmitting('moveToOrder') ||
        this.isSubmitting('create')
      );
    },
    optionForms() {
      return [{ data: cloneDeep(this.filteredForms) }];
    },
    /**
     * Tạo mới KHÔNG cho nhập thông tin thanh toán: tiền cọc / trả góp phải đi kèm
     * giao dịch thanh toán thật, gõ tay lúc tạo sẽ ra đơn "đã cọc" mà không có payment.
     */
    isPaymentLocked() {
      return this.isCreate || this.htmlIsValid(this.preOrder, 'installment');
    },
    /**
     * Danh sách chọn chỉ gồm nguồn đang hoạt động. Đơn cũ có thể gắn nguồn đã ngưng —
     * thêm tạm nguồn đó vào để ô chọn vẫn hiện đúng thay vì trống.
     */
    orderSourceOptions() {
      const currentId = this.preOrder.orderSourceId;
      if (
        !currentId ||
        this.orderSources.some((source) => source.id === currentId)
      ) {
        return this.orderSources;
      }
      return [
        ...this.orderSources,
        { id: currentId, name: this.preOrder.orderSourceName || `#${currentId}` },
      ];
    },
    productSearchConfig() {
      return {
        searchType: 'autosuggest',
        titleLabel: 'Máy khách muốn sở hữu',
        searchPlaceholder: 'Tìm kiếm tên, mã, barcode sản phẩm',
        showHeader: true,
        showTable: true,
        showActions: true,
        showSearchTypeSelect: true,
        searchTypeOptions: [
          { id: 1, name: 'Tìm sản phẩm' },
          { id: 2, name: 'Tìm sản phẩm imei' },
        ],
      };
    },
    tradeInSearchConfig() {
      return {
        searchType: 'treeselect',
        searchPlaceholder: 'Tìm kiếm tên, mã, barcode sản phẩm',
        showHeader: false,
        showTable: true,
        showActions: false,
        noResultsText:
          'Không có kết quả, vui lòng cài đặt chương trình thu cũ cho sản phẩm',
        loadOptions: this.loadTradeInProducts,
        defaultOptions: this.defaultTradeInOptions || [],
        showSearchTypeSelect: true,
        searchTypeOptions: [{ id: 1, name: 'Tìm sản phẩm' }],
      };
    },
    isCustomerProductMapped() {
      return !!this.preOrder.customerProductId;
    },
    isPreOrderTradeIn() {
      return this.preOrder.formType === PRE_ORDER_FORM_TYPE.RECEIVE_TRADE_IN;
    },
    optionStores() {
      return [{ data: cloneDeep(this.filteredStores) }];
    },
    optionCustomers() {
      return [{ data: cloneDeep(this.filteredCustomers) }];
    },
    optionProducts() {
      return [{ data: cloneDeep(this.filteredProducts) }];
    },
    optionInstallment() {
      return [{ data: cloneDeep(this.filteredInstallments) }];
    },
  },
  created() {
    this.fetchInstallments();
  },
  watch: {
    $props: {
      handler() {
        // Đang tạo mới thì KHÔNG nạp lại từ params (đó là đơn đang sửa lần trước) —
        // nếu không form đang nhập sẽ bị xoá trắng mỗi khi màn cha đổi dữ liệu.
        if (this.isCreate) {
          return;
        }
        this.initialParams();
      },
      deep: true,
      immediate: true,
    },
    watch: {
      'preOrder.wantUpgrade'() {
        this.setDefaultTab();
      },
      isPreOrderTradeIn() {
        this.setDefaultTab();
      },
    },
  },
  validations: {},
  methods: {
    convertPrice,
    checkPermissions,
    htmlIsValid(item, action) {
      let check = false;
      switch (action) {
        case 'installment': {
          if (item.orderId && !item.orderWarning) {
            check = true;
          }
          break;
        }
      }
      return check;
    },
    formatProductName(data) {
      return [data.productName, data.size, data.color]
        .filter((item) => item)
        .join(' - ');
    },
    handleModalClosed() {
      this.resetPreOrder();
      this.isCreate = false;
    },
    resetPreOrder() {
      this.preOrder = {
        orderId: null,
        storeId: null,
        customerId: null,
        customerMobile: null,
        customerName: null,
        customerEmail: null,
        customerAddress: null,
        formId: null,
        formName: null,
        orderSourceId: null,
        status: 1,
        notes: null,
        productId: null,
        productName: null,
        productNameSearch: null,
        searchProductType: 1,
        installMoneyAccountId: null,
        installMoneyCode: null,
        installMoneyAmount: 0,
        partnerPaymentStatus: null,
        attributes: [],
        products: [],
        totalPointText: null,
        id: null,
        updatedAt: null,
        customerProductId: null,
        customerProduct: {},
      };
      this.selectedTradeInProduct = {
        productId: null,
        productName: null,
        productCode: null,
        barCode: null,
        sellingPrice: null,
      };
    },
    initialParams() {
      // Reset preOrder về trạng thái ban đầu
      this.resetPreOrder();
      this.preOrder.productNameSearch = '';
      this.preOrdersProduct = [];
      this.tradeInDataReady = true;
      this.histories = [];

      if (!isEmpty(this.params)) {
        const paramsClone = cloneDeep(this.params);
        assign(this.preOrder, paramsClone);

        this.titelModal = 'Không có chương trình';
        if (this.preOrder.formName && this.preOrder.formName.length) {
          this.titelModal = `<div>
              <span class='text-primary d-block' style='font-size: 1.1rem'>#${this.preOrder.id}</span>
              <span class='mb-0 px-0 d-block'>${this.preOrder.formName}</span>
              </div>
             `;
        }

        // Chỉ thêm vào preOrdersProduct nếu có productId và product
        if (this.preOrder.productId && this.preOrder.product) {
          this.preOrdersProduct.push({
            ...this.preOrder.product,
            productId: this.preOrder.productId,
          });
        }

        if (this.preOrder.customerProductId && this.preOrder.customerProduct) {
          this.selectedTradeInProduct = {
            productId: this.preOrder.customerProductId,
            productName: this.preOrder.customerProduct.productName,
            productCode: this.preOrder.customerProduct.productCode || null,
            barCode: this.preOrder.customerProduct.barCode || null,
            sellingPrice: this.preOrder.customerProduct.sellingPrice,
          };
        }

        this.getPreOrderHistoryById(this.preOrder.id);
        this.getPreOrderStoreNotes(this.preOrder.id);
      }

      if (!isEmpty(this.stores)) {
        const stores = this.stores.filter((store) => store.id !== -1);
        this.filteredStores = this.optionStoresTmp = stores;
      }
      this.$nextTick(() => {
        this.setDefaultTab();
      });
    },
    showModal() {
      this.isCreate = false;
      if (!this.orderSources.length) {
        this.fetchOrderSources();
      }
      this.$bvModal.show('editPreOrder-pre-order');
      this.initialParams();
    },
    /** Mở modal ở chế độ TẠO MỚI: form trắng, cùng giao diện với lúc sửa */
    showCreateModal() {
      this.isCreate = true;
      this.resetPreOrder();
      this.preOrder.productNameSearch = '';
      this.preOrdersProduct = [];
      this.tradeInDataReady = true;
      this.histories = [];
      this.storeNotes = [];
      this.activeTabIndex = 0;
      this.titelModal = 'Tạo mới đơn đặt trước';
      this.filteredCustomers = [];
      this.filteredProducts = [];
      this.filteredForms = (this.forms || []).slice(0, 10);
      if (!isEmpty(this.stores)) {
        const stores = this.stores.filter((store) => store.id !== -1);
        this.filteredStores = this.optionStoresTmp = stores;
      }
      if (!this.orderSources.length) {
        this.fetchOrderSources();
      }
      this.$bvModal.show('editPreOrder-pre-order');
    },
    fetchOrderSources() {
      ApiService.query('orderSources/getAll', { params: { status: 1 } })
        .then((response) => {
          this.orderSources = response.data.data || [];
        })
        .catch(() => makeToastFaile('Không tải được nguồn đơn hàng!'));
    },
    /** Gõ tên chương trình: bỏ chương trình đã chọn, tên trùng khít thì lấy lại đúng id */
    searchForm(textInput) {
      const forms = this.forms || [];
      const keyword = removeAccents(textInput || '')
        .toLowerCase()
        .trim();
      const exact = forms.find(
        (form) =>
          removeAccents(form.name || '')
            .toLowerCase()
            .trim() === keyword,
      );
      this.preOrder.formId = exact ? exact.id : null;
      this.filteredForms = keyword
        ? this.fitlerOptionsBy(forms, textInput, ['name'], 10)
        : forms.slice(0, 10);
    },
    /**
     * Chọn chương trình từ gợi ý: phải tự gán cả TÊN, vì vue-autosuggest chỉ đẩy
     * chữ người dùng GÕ vào v-model — bấm chọn mà không gõ thì formName vẫn trống.
     */
    onSelectedForm(option) {
      if (!option) {
        return;
      }
      this.preOrder.formId = option.item.id;
      this.preOrder.formName = option.item.name;
    },
    validateCreate() {
      const preOrder = this.preOrder;
      if (!preOrder.orderSourceId) {
        return 'Vui lòng chọn nguồn đơn hàng';
      }
      if (!(preOrder.formName || '').trim()) {
        return 'Vui lòng nhập chương trình';
      }
      if (!(preOrder.customerMobile || '').trim()) {
        return 'Vui lòng nhập SĐT khách hàng';
      }
      if (!(preOrder.customerName || '').trim()) {
        return 'Vui lòng nhập họ tên khách hàng';
      }
      if (!preOrder.productId) {
        return 'Vui lòng chọn sản phẩm khách muốn sở hữu';
      }
      return null;
    },
    callCreatePreOrder() {
      const message = this.validateCreate();
      if (message) {
        return makeToastFaile(message);
      }
      return this.withSubmitLock('create', async () => {
        const preOrder = this.preOrder;
        const product = this.preOrdersProduct[0] || {};
        const orderSource = this.orderSources.find(
          (source) => source.id === preOrder.orderSourceId,
        );
        const payload = {
          orderSourceId: preOrder.orderSourceId,
          orderSourceName: orderSource ? orderSource.name : '',
          formId: preOrder.formId,
          formName: preOrder.formName.trim(),
          storeId: preOrder.storeId,
          status: preOrder.status,
          notes: preOrder.notes,
          customerMobile: preOrder.customerMobile,
          customerName: preOrder.customerName,
          customerEmail: preOrder.customerEmail,
          customerAddress: preOrder.customerAddress,
          productId: preOrder.productId,
          productName: product.productNameSystem || product.productName,
          productPrice: Number(product.sellingPrice) || 0,
          // Sản phẩm thu cũ (tab 2): lưu cả id lẫn tên máy khách đang sở hữu
          customerProductId: preOrder.customerProductId,
          customerCurrentPhone: this.selectedTradeInProduct.productName,
        };
        try {
          const response = await ApiService.post('/pre-orders', payload);
          if (!response.data.status) {
            return makeToastFaile(response.data.message || 'Lỗi');
          }
          makeToastSuccess('Tạo đơn đặt trước thành công!');
          this.$bvModal.hide('editPreOrder-pre-order');
          this.$emit('onRefresh', true);
        } catch (error) {
          makeToastFaile(
            error.response && error.response.data
              ? error.response.data.message
              : error.message || 'Lỗi',
          );
        }
      });
    },
    onInputed(textInput = '', type) {
      switch (type) {
        case 'Customer': {
          if (!textInput || !textInput.trim().length) {
            return;
          }
          this.debounceInput(textInput, this.searchCustomerAPI);
          break;
        }
        case 'Product': {
          if (!textInput || !textInput.trim().length) {
            return;
          }
          this.debounceInput(textInput, this.searchProductAPI);
          break;
        }
        case 'Store':
          this.debounceInput(textInput, this.searchStore);
          break;
        case 'Form':
          this.searchForm(textInput);
          break;
        case 'Installment':
          this.debounceInput(textInput, this.searchInstallment);
          break;
        default:
          break;
      }
    },
    onSelected({ item }, type) {
      switch (type) {
        case 'Customer':
          this.getCustomerInfoById(item.id);
          break;
        case 'Product':
          this.handleSelectedProduct(item);
          break;
        default:
          break;
      }
    },
    removePreOrdersProduct() {
      this.preOrdersProduct = [];
      this.preOrder.productId = null;
    },
    callUpdatePreOrderBy(type) {
      return this.withSubmitLock(type, async () => {
        // Nút Chuyển được phép bỏ qua conflict (xem updatePreOrder); nút Lưu thì không.
        const response = await this.updatePreOrder({
          ignoreConflict: type === 'moveToOrder',
        });
        if (!response) return;
        switch (type) {
          case 'moveToOrder': {
            const routeData = this.$router.resolve({
              name: 'add-order',
              query: { fromPreOrder: this.preOrder.id },
            });
            window.open(routeData.href, '_blank');
            break;
          }
          case 'update':
            makeToastSuccess(response.data.message);
            this.getPreOrderHistoryById(this.preOrder.id);
            this.$emit('onRefresh', response.data.data);
            break;
          default:
            break;
        }
      });
    },
    debounceInput: debounce((textInput, fn) => {
      fn(textInput);
    }, TIME_TRIGGER),
    handleSelectedProduct(product) {
      this.preOrdersProduct = [];
      this.preOrder.productId = product.productId;
      this.preOrdersProduct.push({
        ...product,
        productNameSystem: product.productName,
      });
    },
    getCustomerInfoById(customerId) {
      ApiService.get(`customer/${customerId}`).then((response) => {
        const result = response.data;
        if (result.status) {
          const dataset = result.data;
          this.preOrder.customerPhone = dataset.phoneNo;
          // Tạo mới: lấy đủ SĐT của khách vừa chọn — ô nhập chỉ giữ phần chữ đã gõ
          if (this.isCreate) {
            this.preOrder.customerMobile = dataset.phoneNo;
          }
          this.preOrder.customerName = dataset.fullName;
          this.preOrder.totalPoint = dataset.totalPoint;
          this.preOrder.totalPointText = ` (Tổng điểm: ${dataset.totalPoint} )`;
        } else {
          makeToastFaile(result.message);
        }
      });
    },
    getPreOrderHistoryById(preOrderId) {
      if (!preOrderId) return;
      ApiService.query(`pre-orders/${preOrderId}/history`).then((response) => {
        if (!response.data.status) {
          makeToastFaile(response.data.message);
          return;
        }
        this.histories = [];
        map(response.data.data, (item) => {
          let data = {
            ...item,
            originalValue: item.originalValue || null,
            newValue: item.newValue || null,
          };
          const items = [data.originalValue, data.newValue];

          map(items, (element) => {
            if (!isEmpty(element) && element.status) {
              element.statusName = null;
              const status = this.optionStatus.find(
                (x) => x.id === element.status,
              );
              if (status) element.statusName = status.name;
            }
          });

          this.histories.push(data);
        });
      });
    },
    getPreOrderStoreNotes(preOrderId) {
      if (!preOrderId) return;
      ApiService.query(`pre-orders/${preOrderId}/store-notes`).then(
        (response) => {
          if (!response.data.status) {
            makeToastFaile(response.data.message);
            return;
          }
          this.storeNotes = (response.data.data && response.data.data.data) || [];
        },
      );
    },
    fetchInstallments: function () {
      ApiService.query('/installments', {
        params: {
          page: 1,
          pageSize: 1000,
        },
      }).then((response) => {
        const installments = response.data.data.result;
        this.filteredInstallments = installments;
        this.optionInstallmentTmp = installments;
      });
    },
    fetchCustomers: function (textSearch) {
      ApiService.query(`customer/get-by-phone`, {
        params: {
          phoneNumber: textSearch,
        },
      }).then((data) => {
        const customers = data.data.data;
        this.filteredCustomers = customers;
      });
    },
    updatePreOrder: function (options = {}) {
      const { ignoreConflict = false } = options;
      const preOrderUpdate = cloneDeep(this.preOrder);

      preOrderUpdate.installMoneyAmount = unMaskPrice(
        preOrderUpdate.installMoneyAmount || 0,
      );

      return ApiService.put('/pre-orders', preOrderUpdate).catch((error) => {
        this.$nprogress.done();
        const message =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        if (typeof message === 'string' && message.includes('PRE_ORDER_CONFLICT')) {
          // Nút "Chuyển qua đơn hàng" được phép bỏ qua conflict: trang tạo đơn hàng
          // tự GET lại pre-order tươi từ BE nên dùng dữ liệu thật, không ghi đè gì.
          // Conflict-check chỉ để bảo vệ luồng Lưu (chống FE cầm bản cũ ghi đè).
          if (ignoreConflict) {
            return { conflictIgnored: true };
          }
          this.showPreOrderConflictModal();
        } else {
          makeToastFaile(message || 'Lỗi');
        }
        return null;
      });
    },
    showPreOrderConflictModal() {
      this.$refs['preorder-conflict-modal'].show();
    },
    // Conflict: không tắt modal, không reload trang — yêu cầu cha tải lại dữ liệu
    // mới nhất của đúng pre-order này rồi mở lại modal với dữ liệu đó.
    reloadPreOrderData() {
      this.$emit('onConflictReload', this.preOrder.id);
    },
    searchCustomerAPI(textInput) {
      this.fetchCustomers(textInput);
    },
    searchProductAPI(textInput) {
      if (this.preOrder.searchProductType === 1) {
        this.fetchProducts(textInput);
      } else {
        this.fetchProductImei(textInput);
      }
    },
    searchStore(textInput) {
      const options = cloneDeep(this.optionStoresTmp);
      if (!textInput || !textInput.trim().length) {
        this.filteredStores = options;
        return;
      }
      const filtered = this.fitlerOptionsBy(
        options,
        textInput,
        ['shortName', 'name'],
        10,
      );
      this.filteredStores = filtered;
    },
    searchInstallment(textInput) {
      const options = cloneDeep(this.optionInstallmentTmp);
      if (!textInput || !textInput.trim().length) {
        this.filteredInstallments = options;
        return;
      }
      const filtered = this.fitlerOptionsBy(options, textInput, ['name'], 10);
      this.filteredInstallments = filtered;
    },
    fitlerOptionsBy(items, textInput, props, limit) {
      return cloneDeep(items)
        .filter((item) => {
          if (item) {
            const nameConcatString = (props || []).reduce((result, prop) => {
              return (result += item[prop] + ' ');
            }, '');

            const nameWTUnicode = removeAccents(nameConcatString).toLowerCase();
            const nameInputWTUnicode = removeAccents(textInput).toLowerCase();
            const index = nameWTUnicode.indexOf(nameInputWTUnicode);

            if (index > -1) {
              return true;
            }
          }
          return false;
        })
        .slice(0, limit);
    },
    fetchProductImei: function (textSearch) {
      const storeId = this.preOrder.storeId ? this.preOrder.storeId : 'null';
      ApiService.query(`productSearch/search-by-imei`, {
        params: {
          storeId: storeId,
          imeiCode: textSearch,
        },
      }).then((response) => {
        const products = response.data.data;
        this.filteredProducts = products;
      });
    },
    fetchProducts: function (textSearch) {
      const storeId = this.preOrder.storeId ? this.preOrder.storeId : 'null';
      ApiService.query('productSearch', {
        params: {
          searchProduct: textSearch,
          storeId: storeId,
        },
      }).then((response) => {
        const products = response.data.data;
        this.filteredProducts = products;
      });
    },
    openCustomerProductMappingModal() {
      // Truyền sản phẩm hiện tại nếu đã có để có thể chỉnh sửa
      const currentProduct = this.preOrder.customerProductId
        ? {
            productId: this.preOrder.customerProductId,
            productName: this.preOrder.customerProduct?.productName,
            sellingPrice: this.preOrder.customerProduct?.sellingPrice,
            barCode: this.preOrder.customerProduct?.barCode,
            productCode: this.preOrder.customerProduct?.productCode,
          }
        : null;

      this.$refs['customer-product-mapping-modal'].openModal(
        this.preOrder.customerCurrentPhone,
        currentProduct,
      );
    },
    onConfirmMapping(product) {
      this.preOrder.customerProductId = product.productId;
      this.preOrder.customerProduct = {
        productName: product.productName,
        sellingPrice: product.sellingPrice,
        barCode: product.barCode,
        productCode: product.productCode,
      };

      makeToastSuccess('Đã gán sản phẩm thành công');
    },
    onTradeInSearchChange(searchQuery) {
      if (searchQuery.length > 1 && !this.isOpenTradeInSearch) {
        this.isOpenTradeInSearch = true;
      } else if (searchQuery.length === 0) {
        this.isOpenTradeInSearch = false;
      }
    },

    onSelectTradeInProduct(node) {
      this.isOpenTradeInSearch = false;
      const itemSelected = cloneDeep(node);
      const product = {
        productId: itemSelected.productId || itemSelected.id,
        productName: itemSelected.productName,
        productCode: itemSelected.productCode,
        barCode: itemSelected.barCode,
        sellingPrice: itemSelected.sellingPrice,
      };
      this.selectedTradeInProduct = product;
      this.preOrder.customerProductId = product.productId;
      this.preOrder.customerProduct = {
        productName: product.productName,
        sellingPrice: product.sellingPrice,
        barCode: product.barCode,
        productCode: product.productCode,
      };
      makeToastSuccess('Đã gán sản phẩm thu cũ thành công');
    },

    fetchTradeInProduct(textSearch) {
      const params = {
        productName: textSearch ? textSearch.trim() : null,
      };
      return ApiService.query('tradeInProgram/by-product-name', {
        params,
      }).then((response) => response.data);
    },

    searchTradeInProductAPI: debounce(function (searchQuery) {
      return this.fetchTradeInProduct(searchQuery);
    }, TIME_TRIGGER),

    async loadTradeInProducts({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const result = await this.searchTradeInProductAPI(searchQuery);
        const products = result?.data || [];

        const optionProduct = products.map((element) => ({
          id: this.$uuid.v4(),
          label: element.productName,
          isDisabled: false,
          ...element,
        }));

        callback(null, optionProduct);
      }
    },
    setDefaultTab() {
      if (this.preOrder.wantUpgrade) {
        this.activeTabIndex = 0;
      } else if (this.isPreOrderTradeIn && this.preOrder.customerCurrentPhone) {
        this.activeTabIndex = 1;
      } else {
        this.activeTabIndex = 0;
      }
    },
  },
};
</script>

<style lang="scss">
#editPreOrder-pre-order {
  .modal-header {
    padding: 0.8rem 1.75rem;
  }
  #history-table tbody tr td > span {
    display: block;
  }
  #history-table tbody tr td > b {
    width: max-content;
  }
  #store-note-table tbody tr td > span {
    display: block;
  }
  #store-note-table tbody tr td > b {
    width: max-content;
  }
  .alert-warning {
    color: #855700;
    background-color: #ffeecc;
    border-color: #ffe7b8;
  }
  .header-table {
    color: rgb(24, 28, 50);
    background-color: #f8f9fa;
  }
  .history-scroll {
    max-height: 220px;
    overflow-y: auto;
  }
  .nav-tabs .nav-link,
  .nav-tabs .nav-link.active {
    font-weight: 900;
  }
  .autosuggest__results-container {
    position: relative;
    width: 100%;
    font-weight: 400;
  }

  .autosuggest__results {
    position: absolute;
    width: 100%;
    max-height: 250px;
    border: 1px solid #e0e0e0;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #fff;
    z-index: 3;
    border-radius: 0 0 0.28rem 0.28rem;
  }

  .autosuggest__results ul {
    list-style: none;
    margin-bottom: 0;
    padding-left: 0;
    cursor: pointer;
  }

  .autosuggest__results ul li {
    padding: 5px 8px;
    border-bottom: 0.1rem solid #e0e0e0;
  }

  .autosuggest__results-item:hover,
  .autosuggest__results .autosuggest__results-item--highlighted {
    background-color: #ddd;
  }

  .autosuggest__results .autosuggest__results-item:active {
    background-color: #e3f2fd;
  }

  .autosuggest__input {
    display: block;
    width: 100%;
    height: calc(1.35em + 1.1rem + 2px);
    line-height: 1.35;
    padding: 0.55rem 0.75rem;
    font-weight: 400;
    font-size: 0.925rem;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.28rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  .autosuggest__input:focus {
    outline: none;
    border: 1px solid #92c5f9;
  }

  .autosuggest__input:disabled {
    background-color: #f3f6f9;
  }
}
</style>
